import { getIsMobile, getIsTablet } from '@bridebook/web/app-basic/lib/app/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';
import { noop } from 'remeda';
import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import { ICommonProps } from '@bridebook/web/app-shared/components/supplier/supplier-card/supplier-card';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { useInfoCard } from './use-info-card';
import useLightweightCarousel from './use-lightweight-carousel';

export const useSupplierCard = () => {
  const { t } = useTranslation();
  const market = useMarket();

  const lightweightCarouselProps = useLightweightCarousel();
  const infoCard = useInfoCard();

  const supplierCardOnClick = noop;
  const enquiryCTAText = t('cta.requestBrochure');
  const isTablet = useSelector(getIsTablet);
  const isMobile = useSelector(getIsMobile);
  const pathname = useSelector((state) => state.app.pathname);
  const searchLocation = useSelector((state) => state.search.fields?.area);
  const locationData = useSelector((state) => state.search.locationData);
  const locationCounty = useSelector(
    (state) => state.search.fields?.addressComponents?.administrative_area_level_2,
  );
  const useIsShortlisted = useCallback(() => false, []);

  const onCarouselUsed = noop;
  const onCarouselInView = noop;

  const props: ICommonProps & { onClick: () => void } = {
    budget: null,
    enquiryCTAText,
    isLoggedIn: false,
    isMobile,
    isTablet,
    isUK: market.country === CountryCodes.GB,
    locationCounty,
    locationData,
    onCarouselInView,
    onCarouselUsed,
    onClick: supplierCardOnClick,
    onContactSupplierClick: infoCard.onContactSupplierClick,
    onViewedEndScreen: lightweightCarouselProps.onViewedEndScreen,
    pathname,
    searchLocation,
    useIsShortlisted,
  };

  return props;
};
